var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"ma-auto",attrs:{"width":_vm.isDesktop ? 350 : '100%',"flat":"","outlined":_vm.isDesktop,"tile":""}},[_c('v-container',{staticClass:"signup-container py-5",attrs:{"fluid":""}},[_c('reset-form')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }